export default "__VITE_ASSET__DUI44Ybk__"